import styled from 'styled-components'

interface DropdownWrapperProps {
  open: boolean
}

const DropdownWrapper = styled.div<DropdownWrapperProps>`
  position: absolute;
  display: ${({ open }) => (open ? `flex` : `none`)};
  overflow: hidden;
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;
  max-height: 164px;
  z-index: 15;
  border: 0.1rem solid ${({ theme }) => theme.color.borderGrey};
  box-shadow: 0.8rem 0 1.6rem rgba(0, 0, 0, 0.05);
  border-radius: 0.4rem;
`

export default DropdownWrapper
